import { Component } from '@angular/core';

import { CardBottomComponent } from '../card-bottom/card-bottom.component';
import { CardHeaderComponent } from '../card-header/card-header.component';
import { CardMainComponent } from '../card-main/card-main.component';
import { CardPhotoComponent } from '../card-photo/card-photo.component';
import { CardTopComponent } from '../card-top/card-top.component';

@Component({
  selector: 'app-card-loader',
  imports: [CardBottomComponent, CardHeaderComponent, CardMainComponent, CardPhotoComponent, CardTopComponent],
  templateUrl: './card-loader.component.html',
  styleUrl: './card-loader.component.scss',
})
export class CardLoaderComponent {}
